<template>
  <div class="login-client">
    <div
      class="container-fluid page-header"
      :style="{ backgroundImage: 'url(' + require('@/assets/landing_page/buildings.jpg') +')' }"
    >
      <div class="row">
        <div class="col-12">
          <div class="page-title">Área do Cliente</div>
          <div class="page-description">Tenha acesso total ao Governet</div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 col-12">
          <div class="card">
            <div class="card-body">
              <div class="form-group">
                <label for>Login</label>
                <input name="login" type="email" class="form-control" v-model="login" />
              </div>
              <div class="form-group">
                <label for>Senha</label>
                <input name="password" type="password" class="form-control" v-model="password" />
                <div class="forgot-password">
                  <span v-on:click="forgotPassword">Esqueceu sua senha?</span>                  
                </div>
                <b style="
                    font-size: 18px;
                    text-align: center;
                    margin-top: 8px;
                ">O sistema faz distinção de caracteres maiúsculos e minúsculos.</b>
              </div>
              <button class="btn btn-primary float-right" v-on:click="loginMethod">Entrar</button>
              <!-- <button class="btn btn-secondary float-left" v-on:click="logout">Sair</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ref="answer-modal"
      id="answer-modal"
      size="lg"
      title="Aviso"
    >
    <div style="text-align: justify;">
    O site da Governet mudou, e não foi só na aparência.<br><br>

    Além do visual mais moderno, o banco de dados foi migrado para um servidor mais estável e mais seguro.

    <br><br>No quesito segurança, o novo sistema é mais rigoroso quanto ao uso da senha cadastrada. Anteriormente, independentemente da forma como a senha fosse cadastrada, era possível acessar o site digitando-a com caracteres <b style="color:#e12323">maiúsculos</b> ou <b style="color:#e12323">minúsculos</b>, de maneira indiferente.

    <br><br>No site novo, o campo senha é sensível a caracteres <b style="color:#e12323">maiúsculos</b> e <b style="color:#e12323">minúsculos</b>. Isso significa que a senha deve ser digitada exatamente como cadastrada, com <b style="color:#e12323">diferenciação entre caixa alta e caixa baixa</b>. 

    <br><br>Solicitamos a gentileza de tentar o acesso tanto com a senha toda <b style="color:#e12323">maiúscula</b> como com a versão toda <b style="color:#e12323">minúscula</b>. Caso o acesso não seja possível após essas tentativas, colocamo-nos à disposição para resolver a questão.

    <br><br>Equipe Governet.

    </div>
    <template v-slot:modal-cancel>Fechar</template>
    <template v-slot:modal-ok>Ok</template>
    </b-modal>
  </div>
</template>

<script>
import auth from "@/api/auth";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "login_cliente",
  data() {
    return {
      login: "",
      password: ""
    };
  },
  mounted() {
    if (
      localStorage.getItem("auth.user_id") != null &&
      localStorage.getItem("auth.user_id") != ""
    ) {
      this.$router.push("/");
    }
    this.$refs["answer-modal"].show();
  },
  methods: {
    loginMethod: function() {
      if (this.login != "" && this.password != "") {
        bus.$emit("changeLoading", true);
        auth
          .login(this.login, this.password)
          .then(data => {
            bus.$emit("changeLoading", false);
            location.reload();
          })
          .catch(error => {
            let msg = "";
            if (error.response.data.error == "Expired") {
              msg = "Sua conta esta expirada";
            }
            else if (error.response.data.error == "Blocked") {
              msg = "Seu usuário esta bloqueado";
            } else {
              msg =
                error.response.status == 418
                  ? "Parece que o limite de logins já foi excedido, tente desconectar dos outros computadores."
                  : "Parece que essas credencias não constam no sistema.";
            }
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Tivemos um problema",
              text: msg,
              icon: "error"
            });
          });
      } else {
        Swal.fire({
          title: "Atenção",
          text: "Preencha todos os campos.",
          icon: "warning"
        });
      }
    },
    forgotPassword: function(){
      Swal.fire({
        title: "Recuperação de senha",
        text: "Insira seu e-mail, iremos enviar uma senha nova.",
        showCancelButton: true,
        confirmButtonText: "Enviar",
        cancelButtonText: "Cancelar",
        input: 'text',
      }).then(result => {
        if(result.value && result.value != ''){
          bus.$emit("changeLoading", true);
          auth.passwordRecovery(result.value)
          .then( res => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Enviamos a senha para o seu e-mail.",
              text: "O e-mail pode demorar alguns minutos.",
              icon: "success"
            });
          })
          .catch( () => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Parece que esse e-mail não consta no sistema.",
              icon: "warning"
            });
          })
        }
      });
      // Swal.fire({
      //   title: "An input!",
      //   text: "Write something interesting:",
      //   input: 'text',
      //   showCancelButton: true,
      //   closeOnConfirm: false,
      //   animation: "slide-from-top",
      //   inputPlaceholder: "Write something"
      // },
      // function(inputValue){
      //   console.log('close', inputValue);
      // });
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.forgot-password{
  margin-top: 6px;
  margin-bottom: 6px;
  color: $red_primary;
  font-size: 14px;
  text-align: end;
  span:hover{
    cursor: pointer;
    filter: brightness(.8);
  }
}
</style>